<template>
  <div class="row m-0">
    <div class="col-12">
      <h1 class="title font-weight-bold text-uppercase">
        PAGAMENTO COTAÇÃO ({{ this.$route.params.id }}) - VIA CARTÃO DE CRÉDITO.
      </h1>
      <hr class="linha-amarela" />
    </div>
    <div class="col-12" v-if="response.status == 'paid'">
      <h1 class="font-weight-bold text-uppercase color-success">
        Pagamento realizado com sucesso
      </h1>
    </div>
    <div class="col">
      <div class="card-wrapper mb-5"></div>
      <form id="cc-form" class="form-group row g-3">
        <label for="email">Número cartão</label>
        <input
          class="form-control mb-3"
          id="cc-number"
          type="text"
          name="number"
          v-model="number"
        />
        <label for="email">Primeiro nome</label>
        <input
          class="form-control mb-3"
          id="cc-name"
          type="text"
          name="first-name"
          v-model="firstname"
        />
        <label for="email">Último nome</label>
        <input
          class="form-control mb-3"
          id="cc-name"
          type="text"
          name="last-name"
          v-model="lastname"
        />
        <label for="email">Mês de expiração do cartão</label>
        <input
          class="form-control mb-3"
          id="cc-expiration"
          type="text"
          name="expiry"
          v-model="month"
        />
        <label for="email">Ano de expiração do cartão</label>
        <input
          class="form-control mb-3"
          id="cc-expiration"
          type="text"
          name="expiry"
          v-model="year"
        />
        <label for="email">CVV/CVC</label>
        <input
          class="form-control mb-3"
          id="cc-cvv"
          type="text"
          name="cvc"
          v-model="cvv"
        />
        <label for="months">Selecione as parcelas</label>
        <select class="form-control" v-model="months" id="months">
          <option
            v-for="(installments, index) in installments"
            :key="index"
            :value="index + 1"
          >
            Pagamento em {{ index + 1 }}x
          </option>
        </select>
        <button @click="submitCC()" class="mt-3 btn btn-success btn-block">Pagar</button>
      </form>
    </div>
  </div>
</template>

<script type="text/javascript" src="https://js.iugu.com/v2"></script>
<script>
import * as Card from 'card';
import { mapState } from 'vuex';
import makeToast from '../../mixins/makeToast';

export default {
  name: 'CartaoDeCreditoCancel',
  data() {
    return {
      response: [],
      number: '',
      firstname: '',
      lastname: '',
      month: '',
      year: '',
      cvv: '',
      token: '',
      months: '',
      installments: 1,
    };
  },
  mixins: [makeToast],
  computed: {
    ...mapState({
      cotacao: (state) => state.cotacao,
      dadosUsuario: (state) => state.dadosUsuario,
      invoices: (state) => state.invoices,
    }),
  },
  mounted() {
    let Script = document.createElement('script');
    Script.setAttribute('src', 'https://js.iugu.com/v2');
    document.head.appendChild(Script);
    this.loadPayment();
    // eslint-disable-next-line no-new
    new Card({
      form: 'form#cc-form',
      container: '.card-wrapper',
      formSelectors: {
        numberInput: 'input#cc-number',
        expiryInput: 'input#cc-month, input#cc-year',
        cvcInput: 'input#cc-cvv',
        nameInput: 'input#cc-name',
      },
      width: 370,
      formatting: true,
      messages: {
        validDate: 'valido\ndata',
        monthYear: 'mm/yyyy',
      },
      placeholders: {
        number: '•••• •••• •••• ••••',
        name: 'Nome completo',
        expiry: '••/••',
        cvc: '•••',
      },
    });
  },
  methods: {
    submitCC() {
      Iugu.setAccountID('5F983047944445BEBF92780DA8970D3F');
      Iugu.setup();
      Iugu.setTestMode(false);
      const cc = Iugu.CreditCard(
        this.number,
        this.month,
        this.year,
        this.firstname,
        this.lastname,
        this.cvv
      );
      Iugu.createPaymentToken(cc, (response) => {
        if (response.errors) {
          this.makeToast('Oops!', 'Não foi possível salvar o cartão', 'danger');
        } else {
          const data = {
            invoice_id: this.response.id,
            token: response.id,
            months: this.months,
          };
          this.$store.dispatch('sendCc', data).then((resp) => {
            if (resp.data.message === 'Fatura paga com sucesso!') {
              this.makeToast(
                'Opa!',
                'Pagamento realizado com sucesso!',
                'success'
              );
              setTimeout(() => {
                this.$router.push({
                  name: 'cliente-rejeitadas-pelo-usuario'
                });
              }, 2000);
            } else {
              this.makeToast(
                'Oops!',
                'Houver um problema ao realizar o pagamento.',
                'danger'
              );
            }
          });
          this.token = response.id;
        }
      });
    },
    loadPayment() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('emptyCotacao')
      .then(() => {
        this.$store
          .dispatch('showCheckoutCancel', this.$route.params.id)
          .then((data) => {
            const response = data.data;
            this.value = response.pix.qrcode_text;
            this.response = response;
          })
          .catch(() => {
            this.$store.dispatch('endLoader');
            this.makeToast(
              'Oops!',
              'Não foi possível carregar o orçamento! Tente novamente em 5 minutos!',
              'danger'
            );
          })
          .finally(() => this.$store.dispatch('endLoader'));
      });
    },
  },
};
</script>

<style scoped>
.color-success {
  color: rgb(237, 118, 70);
}
</style>